export function getUrlWithProxy(url: string): string {
	return window.App && window.App.proxyurl
		? `${window.App.proxyurl}${url}`
		: url;
}

export function getAbsoluteUrlWithProxy(url: string): string {
	const baseUrl =
		window.App && window.App.proxyurl
			? window.App.proxyurl
			: `${window.location.protocol}//${window.location.host}`;

	return `${baseUrl}${url}`;
}

export function getProxyPath(): string {
	if (!window.App || !window.App.proxyurl) {
		return '';
	}

	const parser = document.createElement('a');
	parser.href = window.App.proxyurl;

	const resultPath = parser.pathname.replace(/\/$/, '');

	return resultPath;
}

export function getTenantPrefix(): string {
	const tenant = window.App?.user?.tenant;
	if (!tenant) {
		return '';
	}

	const urlHost = window.location.host;
	const { tenantDomainNames, name: tenantName } = tenant;
	const isDNS =
		urlHost &&
		tenantDomainNames &&
		tenantDomainNames.some((dnsUrl) => dnsUrl.includes(urlHost));
	const tenantPrefix =
		isDNS || tenantName === 'system'
			? ''
			: tenantName
			? `/${tenantName}`
			: '';

	return tenantPrefix;
}
